import { useOnlineStatus, usePendingSyncCount } from "@/hooks/useOnlineStatus";
import { WifiOff, CloudOff, RefreshCw, Check } from "lucide-react";
import { syncPendingItems } from "@/lib/syncService";
import { useState } from "react";

const OfflineIndicator = () => {
  const isOnline = useOnlineStatus();
  const pendingCount = usePendingSyncCount();
  const [syncing, setSyncing] = useState(false);

  const handleManualSync = async () => {
    if (!isOnline || syncing) return;
    setSyncing(true);
    await syncPendingItems();
    setSyncing(false);
  };

  // Nothing to show
  if (isOnline && pendingCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-sm mx-auto">
      {!isOnline && (
        <div className="bg-destructive text-destructive-foreground rounded-xl px-4 py-3 shadow-lg flex items-center gap-3 mb-2">
          <WifiOff className="h-5 w-5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">Sem conexão</p>
            <p className="text-xs opacity-80">Seus dados serão salvos localmente</p>
          </div>
        </div>
      )}

      {pendingCount > 0 && (
        <div
          className={`rounded-xl px-4 py-3 shadow-lg flex items-center gap-3 cursor-pointer active:scale-[0.98] transition-transform ${
            isOnline ? "bg-warning text-warning-foreground" : "bg-muted text-muted-foreground"
          }`}
          onClick={handleManualSync}
        >
          {syncing ? (
            <RefreshCw className="h-5 w-5 shrink-0 animate-spin" />
          ) : (
            <CloudOff className="h-5 w-5 shrink-0" />
          )}
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">
              {pendingCount} {pendingCount === 1 ? "item pendente" : "itens pendentes"}
            </p>
            <p className="text-xs opacity-80">
              {isOnline
                ? syncing
                  ? "Sincronizando..."
                  : "Toque para sincronizar agora"
                : "Será enviado quando houver internet"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
